module.exports = __webpack_public_path__ + "img/w3_bil_grey.88cf4aac.png";